import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-card',
	templateUrl:'./WaCardPage.html',
	styles: [],
	styleUrls:['./WaCardPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaCardPage
{
	mdContent_299 = `\`\`\`java
import com.jwebmp.webawesome.components.card.WaCard;
\`\`\``;
	mdContent_300 = `\`\`\`java
new WaCard<>()
\`\`\``;
	mdContent_301 = `\`\`\`java
var card = new WaCard<>();
card.setAppearance(Appearance.Outlined);
card.withText("Hello world");
\`\`\``;
	mdContent_302 = `\`\`\`java
var card = new WaCard<>();
card.setAppearance(Appearance.Filled);
card.withHeader("Card Title");
card.withText("This is the card body content.");
var footer = new DivSimple<>();
footer.add(new WaButton<>("Action", Variant.Brand));
card.withFooter(footer);
\`\`\``;
	mdContent_303 = `\`\`\`java
var card = new WaCard<>();
card.withImage(new Image<>("photo.jpg"));
card.withHeader("Photo");
card.withText("A beautiful landscape.");
\`\`\``;
}
